import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { catchError, filter, ignoreElements, map, mergeMap } from "rxjs/operators";
import { DamActions } from "./dam.actions";
import * as actions from "../store/dam.actions";
import { isActionType } from "../../../redux/action.functions";
import * as damServices from "../services/dam.service";
import { of } from "rxjs";
import { StateObservable } from "redux-observable";
import { RootState } from "../../../redux/store";
import * as store from "../store/dam.store";

const init: Effect = (action$: EffectActionsObservable, state$: StateObservable<RootState>) =>
  action$.pipe(
    filter(isActionType(DamActions.Init)),
    map(() => ({
      signature: store.getSignature(state$.value),
      signatureFetchedAt: store.getSignatureFetchedAt(state$.value),
    })),
    map(({ signature, signatureFetchedAt }) =>
      damServices.signatureValid(signature, signatureFetchedAt)
        ? ignoreElements()
        : actions.fetchSignature()
    )
  );

const fetchSignature: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(DamActions.FetchSignature)),
    mergeMap(() =>
      damServices.fetchSignature().pipe(
        map((signature) => actions.fetchSignatureSuccess(signature, new Date())),
        catchError((error) => of(actions.fetchSignatureFailure(error)))
      )
    )
  );

export const DamEffects = [fetchSignature, init];
